import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    _createVNode("path", { d: "M12 20.5a8.5 8.5 0 100-17 8.5 8.5 0 000 17zM8.86 8.011l7.639 2.063M13.089 7.27l.406-1.774M10.503 18.504l.408-1.773M8.18 10.969l7.636 2.066M7.5 13.925l7.638 2.064" })
  ]))
}